import { Divider, Stack, Typography } from "@mui/material";
import PathologyOrderSummary from ".";
import MaxWidthContainer from "../../../Common/components/MaxWidthContainer";
import {
  MembershipDependentIdentityDocumentType,
  PathologyOrderStatus,
  PathologyPanelChargeCode,
  PathologyPaymentReceipt,
} from "@/services/core-api-adapter";

export default function PathologyOrderSummaryExamples() {
  const pendingData = {
    orderId: "1",
    panelName: "STD Screening (excl HIV)",
    panelChargeCode: PathologyPanelChargeCode.STD_SCREENING_EXCL_HIV,
    orderNumber: "12345",
    orderUnuFeeAmount: 0,
    isDiscountApplied: false,
    discountAmount: 30,
    discountAmountFormatted: "R30",
    originalAmount: 100,
    originalAmountFormatted: "R100",
    unuHandlingFeeAmount: 10,
    unuHandlingFeeAmountFormatted: "R10",
    unuTransactionalFeeAmount: 10,
    unuTransactionalFeeAmountFormatted: "R10",
    orderPrice: 100,
    created: "2021-10-10T10:00:00Z",
    hasGivenContactConsent: true,
    testSubjectMemberId: "123-456-789",
    amountTotalFormatted: "R100",
    status: PathologyOrderStatus.PENDING,
    orderPathologyTests: [
      {
        testName: "STD PCR",
        testAmount: 0,
        testCode: "1234",
      },
      {
        testName: "Hep B surface antigen",
        testAmount: 0,
        testCode: "1234",
      },
      {
        testName: "Syphilis RPR + T Pallidum ELISA",
        testAmount: 0,
        testCode: "1234",
      },
    ],
  };

  const completedData = {
    orderId: "1",
    panelName: "General Screening - Male over 45",
    panelChargeCode: PathologyPanelChargeCode.MALE_OVER_45,
    orderUnuFeeAmount: 0,
    orderNumber: "12345",
    orderPrice: 100,
    isDiscountApplied: true,
    discountAmount: 30,
    discountAmountFormatted: "R30",
    originalAmount: 100,
    originalAmountFormatted: "R100",
    unuHandlingFeeAmount: 10,
    unuHandlingFeeAmountFormatted: "R10",
    unuTransactionalFeeAmount: 10,
    unuTransactionalFeeAmountFormatted: "R10",
    created: "2021-10-10T10:00:00Z",
    hasGivenContactConsent: true,
    testSubjectMemberId: "123-456-789",
    amountTotalFormatted: "R100",
    status: PathologyOrderStatus.COMPLETED,
    orderPathologyTests: [
      {
        testName: "STD PCR",
        testAmount: 0,
        testCode: "1234",
      },
      {
        testName: "Hep B surface antigen",
        testAmount: 0,
        testCode: "1234",
      },
      {
        testName: "Syphilis RPR + T Pallidum ELISA",
        testAmount: 0,
        testCode: "1234",
      },
    ],
  };

  const noOrderNumberData = {
    orderId: "1",
    panelName: "STD Screening (excl HIV)",
    panelChargeCode: PathologyPanelChargeCode.STD_SCREENING_EXCL_HIV,
    orderUnuFeeAmount: 0,
    isDiscountApplied: false,
    discountAmount: 30,
    discountAmountFormatted: "R30",
    originalAmount: 100,
    originalAmountFormatted: "R100",
    unuHandlingFeeAmount: 10,
    unuHandlingFeeAmountFormatted: "R10",
    unuTransactionalFeeAmount: 10,
    unuTransactionalFeeAmountFormatted: "R10",
    orderNumber: "",
    orderPrice: 100,
    created: "2021-10-10T10:00:00Z",
    hasGivenContactConsent: true,
    testSubjectMemberId: "123-456-789",
    amountTotalFormatted: "R100",
    status: PathologyOrderStatus.CONFIRMED,
    orderPathologyTests: [
      {
        testName: "STD PCR",
        testAmount: 0,
        testCode: "1234",
      },
      {
        testName: "Hep B surface antigen",
        testAmount: 0,
        testCode: "1234",
      },
      {
        testName: "Syphilis RPR + T Pallidum ELISA",
        testAmount: 0,
        testCode: "1234",
      },
    ],
  };

  return (
    <MaxWidthContainer>
      <Stack spacing={2}>
        <Typography variant="h3" fontWeight="bold" textAlign="center" mb={2}>
          Pathology Order Summary (Not pending)
        </Typography>
        <Stack mb={3}>
          <PathologyOrderSummary
            onViewResultsClick={() => {
              console.log("on View results clicked");
            }}
            order={completedData}
            paymentReceipt={
              {
                paymentSuccess: true,
                status: "PAYMENT_SUCCEEDED",
                paymentUtcDateTime: "2025-02-05T08:47:48.554992+00:00",
                paymentAmount: 55400,
                currencyCode: "ZAR",
                transactionReferenceNumber:
                  "d42b80a1-ef7f-4f97-84cf-c8ffe85ec432",
                unuMerchantId: "MR0685549892",
                cardNumber: "45485813******70",
              } as PathologyPaymentReceipt
            }
            paymentDate="2021-10-10T10:00:00Z"
            onViewReceiptClick={() => {
              console.log("Payment receipt clicked");
            }}
            onBackButtonClick={() => {
              console.log("Back button clicked");
            }}
            onHowToPrepareClick={() => {
              console.log("How to prepare clicked");
            }}
            selectedDependant={{
              memberId: "dd9def3e-cefc-4e6b-8777-da863dae0be6",
              firstName: "Joe",
              lastName: "Persona edit",
              identityDocumentType:
                MembershipDependentIdentityDocumentType.ID_NUMBER,
              identityDocumentValue: "1301010465087",
              sexAtBirth: "Male",
              dateOfBirth: "2013-01-01",
              identityDocumentCountryOfIssue: "ZAF",
            }}
          />
        </Stack>
        <Divider />
        <Typography variant="h3" fontWeight="bold" textAlign="center" mb={2}>
          Pathology Order Summary (pending)
        </Typography>
        <Stack>
          <PathologyOrderSummary
            onViewResultsClick={() => {
              console.log("on View results clicked");
            }}
            paymentReceipt={
              {
                paymentSuccess: true,
                status: "PAYMENT_SUCCEEDED",
                paymentUtcDateTime: "2025-02-05T08:47:48.554992+00:00",
                paymentAmount: 55400,
                currencyCode: "ZAR",
                transactionReferenceNumber:
                  "d42b80a1-ef7f-4f97-84cf-c8ffe85ec432",
                unuMerchantId: "MR0685549892",
                cardNumber: "45485813******70",
              } as PathologyPaymentReceipt
            }
            order={pendingData}
            paymentDate="2021-10-10T10:00:00Z"
            onViewReceiptClick={() => {
              console.log("Payment receipt clicked");
            }}
            onBackButtonClick={() => {
              console.log("Back button clicked");
            }}
            onHowToPrepareClick={() => {
              console.log("How to prepare clicked");
            }}
          />
        </Stack>

        <Divider />

        <Typography variant="h3" fontWeight="bold" textAlign="center" mb={2}>
          Pathology Order Summary without order number
        </Typography>
        <Stack mb={3}>
          <PathologyOrderSummary
            onViewResultsClick={() => {
              console.log("on View results clicked");
            }}
            order={noOrderNumberData}
            paymentReceipt={
              {
                paymentSuccess: true,
                status: "PAYMENT_SUCCEEDED",
                paymentUtcDateTime: "2025-02-05T08:47:48.554992+00:00",
                paymentAmount: 55400,
                currencyCode: "ZAR",
                transactionReferenceNumber:
                  "d42b80a1-ef7f-4f97-84cf-c8ffe85ec432",
                unuMerchantId: "MR0685549892",
                cardNumber: "45485813******70",
              } as PathologyPaymentReceipt
            }
            paymentDate="2021-10-10T10:00:00Z"
            onViewReceiptClick={() => {
              console.log("Payment receipt clicked");
            }}
            onBackButtonClick={() => {
              console.log("Back button clicked");
            }}
            onHowToPrepareClick={() => {
              console.log("How to prepare clicked");
            }}
          />
        </Stack>

        <Typography variant="h3" fontWeight="bold" textAlign="center" mb={2}>
          Pathology Order Summary (refund in progress)
        </Typography>
        <Stack mb={3}>
          <PathologyOrderSummary
            onViewResultsClick={() => {
              console.log("on View results clicked");
            }}
            order={{
              ...noOrderNumberData,
              status: PathologyOrderStatus.CANCELLED,
            }}
            paymentReceipt={
              {
                paymentSuccess: true,
                status: "PAYMENT_SUCCEEDED",
                paymentUtcDateTime: "2025-02-05T08:47:48.554992+00:00",
                paymentAmount: 55400,
                currencyCode: "ZAR",
                transactionReferenceNumber:
                  "d42b80a1-ef7f-4f97-84cf-c8ffe85ec432",
                unuMerchantId: "MR0685549892",
                cardNumber: "45485813******70",
              } as PathologyPaymentReceipt
            }
            paymentDate="2021-10-10T10:00:00Z"
            onViewReceiptClick={() => {
              console.log("Payment receipt clicked");
            }}
            onBackButtonClick={() => {
              console.log("Back button clicked");
            }}
            onHowToPrepareClick={() => {
              console.log("How to prepare clicked");
            }}
          />
        </Stack>

        <Typography variant="h3" fontWeight="bold" textAlign="center" mb={2}>
          Pathology Order Summary (refunded)
        </Typography>
        <Stack mb={3}>
          <PathologyOrderSummary
            onViewResultsClick={() => {
              console.log("on View results clicked");
            }}
            order={{
              ...noOrderNumberData,
              status: PathologyOrderStatus.CANCELLED,
            }}
            paymentReceipt={
              {
                paymentSuccess: true,
                status: "PAYMENT_REFUNDED",
                paymentUtcDateTime: "2025-02-05T08:47:48.554992+00:00",
                paymentAmount: 55400,
                currencyCode: "ZAR",
                transactionReferenceNumber:
                  "d42b80a1-ef7f-4f97-84cf-c8ffe85ec432",
                unuMerchantId: "MR0685549892",
                cardNumber: "45485813******70",
              } as PathologyPaymentReceipt
            }
            paymentDate="2021-10-10T10:00:00Z"
            onViewReceiptClick={() => {
              console.log("Payment receipt clicked");
            }}
            onBackButtonClick={() => {
              console.log("Back button clicked");
            }}
            onHowToPrepareClick={() => {
              console.log("How to prepare clicked");
            }}
          />
        </Stack>
      </Stack>
    </MaxWidthContainer>
  );
}
